<div class="finances-container">

    <div class="header">
        <div class="left">
            <h2 mat-title>Credit Card</h2>
        </div>
        <app-month-picker></app-month-picker>
        <div class="right"></div>
    </div>

    <!-- Cards -->
    <div class="cards">
        <button *ngFor="let card of cards" [class.selected]="card.id == selected?.id" [class.inactive]="!card.active"
            mat-stroked-button (click)="select(card)">
            <mat-icon>credit_card</mat-icon> {{ card.name }}
        </button>
        <button mat-stroked-button (click)="editCard()" title="Adicionar cartão">
            <mat-icon class="material-symbols-outlined">{{icons.add}}</mat-icon> Add card
        </button>
    </div>

    <p class="empty" *ngIf="!cards.length">Add a card to start registering its statements.</p>

    <ng-container *ngIf="selected">
        <div class="card-header">
            <h3>
                {{ selected.name }}
                <small *ngIf="selected.closingDay || selected.dueDay">
                    <span *ngIf="selected.closingDay">fecha dia {{ selected.closingDay }}</span>
                    <span *ngIf="selected.closingDay && selected.dueDay"> · </span>
                    <span *ngIf="selected.dueDay">vence dia {{ selected.dueDay }}</span>
                </small>
            </h3>
            <div>
                <button mat-icon-button (click)="editCard(selected)" title="Editar cartão"><mat-icon color="primary" class="material-symbols-outlined">{{icons.edit}}</mat-icon></button>
                <button mat-icon-button (click)="deleteCard(selected)" title="Excluir cartão"><mat-icon color="primary" class="material-symbols-outlined">{{icons.delete}}</mat-icon></button>
            </div>
        </div>

        <!-- Statement files of the month -->
        <section class="statements">
            <h4>Statement (PDF)</h4>
            <div class="statement-files">
                <span *ngFor="let s of statements" class="statement-file">
                    <button mat-stroked-button (click)="download(s)" [title]="'Download ' + s.name">
                        <mat-icon>picture_as_pdf</mat-icon> {{ s.name }}
                    </button>
                    <button mat-icon-button (click)="read(s)" [disabled]="reading?.isReading" [title]="'Ler itens de ' + s.name">
                        <mat-icon>document_scanner</mat-icon>
                    </button>
                    <button mat-icon-button (click)="deleteStatement(s)" [title]="'Excluir ' + s.name">
                        <mat-icon class="material-symbols-outlined">{{icons.delete}}</mat-icon>
                    </button>
                </span>
                <input hidden #statementInput type="file" accept="application/pdf" (change)="upload($event)">
                <button mat-raised-button (click)="statementInput.click()" [disabled]="isUploading">
                    <mat-icon>upload_file</mat-icon> {{ isUploading ? 'Uploading...' : 'Upload statement' }}
                </button>
            </div>
            <p class="hint">Ao enviar a fatura, os itens são lidos e aparecem abaixo para revisão antes de serem gravados.</p>
        </section>

        <!-- Items read from a statement, waiting for review -->
        <section *ngIf="reading" class="reading">
            <div class="header">
                <h4>Reading {{ reading.statement.name }}</h4>
                <button mat-icon-button (click)="reading = null" title="Fechar"><mat-icon>close</mat-icon></button>
            </div>

            <div *ngIf="reading.isReading">Lendo o PDF...</div>

            <form *ngIf="reading.needsPassword" class="password" (ngSubmit)="readText()">
                <mat-form-field>
                    <mat-label>Senha do PDF</mat-label>
                    <input matInput type="password" [(ngModel)]="reading.password" name="password" autocomplete="off" required>
                    <mat-hint>Geralmente parte do CPF</mat-hint>
                </mat-form-field>
                <button mat-raised-button type="submit" [disabled]="!reading.password || reading.isReading">Abrir</button>
                <p class="error" *ngIf="reading.incorrectPassword">Senha incorreta.</p>
            </form>

            <div *ngIf="reading.parsed && !reading.rows.length && !reading.isReading" class="no-items">
                <p>Nenhum lançamento encontrado nesta fatura.</p>
                <p *ngIf="reading.parsed.total != null || reading.parsed.dueDate">
                    <span *ngIf="reading.parsed.total != null">Total da fatura R$ {{ reading.parsed.total | number:'1.2-2' }}</span>
                    <span *ngIf="reading.parsed.total != null && reading.parsed.dueDate"> · </span>
                    <span *ngIf="reading.parsed.dueDate">vencimento {{ reading.parsed.dueDate }}</span>
                    <span *ngIf="reading.parsed.total != null && reading.parsed.total < 0"> (saldo a seu favor)</span>
                </p>
                <p class="hint">Se a fatura tem lançamentos, o texto lido está no console do navegador (CardsComponent -> readText).</p>
            </div>

            <ng-container *ngIf="reading.parsed && reading.rows.length">
                <p class="reading-summary">
                    {{ reading.rows.length }} itens encontrados
                    <span *ngIf="reading.parsed.dueDate"> · vencimento {{ reading.parsed.dueDate }}</span>
                    <span *ngIf="reading.parsed.total != null"> · total da fatura R$ {{ reading.parsed.total | number:'1.2-2' }}</span>
                    · selecionados R$ {{ readingTotal | number:'1.2-2' }}
                    <span class="warning" *ngIf="reading.parsed.total != null && readingTotal != reading.parsed.total"> (diferente do total da fatura)</span>
                </p>

                <div class="table-wrapper">
                    <table class="reading-table">
                        <thead>
                            <tr>
                                <th><mat-checkbox [checked]="true" (change)="toggleAll($event.checked)" title="Marcar todos"></mat-checkbox></th>
                                <th>Date</th><th>Description</th><th>Category</th><th>Installment</th><th class="value">Value</th><th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of reading.rows; let i = index" [class.excluded]="!row.include">
                                <td><mat-checkbox [(ngModel)]="row.include" [name]="'include' + i"></mat-checkbox></td>
                                <td>{{ row.date }}</td>
                                <td><input class="description" [(ngModel)]="row.description" [name]="'description' + i"></td>
                                <td>
                                    <select [(ngModel)]="row.category" [name]="'category' + i">
                                        <option value="">—</option>
                                        <option *ngFor="let c of categories" [value]="c.name">{{ c.name }}</option>
                                    </select>
                                </td>
                                <td>{{ row.installment ? row.installment + '/' + row.installments : '' }}</td>
                                <td class="value"><input class="amount" type="number" step="0.01" [(ngModel)]="row.value" [name]="'value' + i"></td>
                                <td class="flags">
                                    <span *ngIf="row.kind == 'payment'" title="Pagamento da fatura anterior">pagamento</span>
                                    <span *ngIf="row.kind == 'credit'" title="Estorno ou crédito">crédito</span>
                                    <span *ngIf="row.exists" title="Mesma descrição e valor já lançados neste mês">já existe</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="reading-actions">
                    <button mat-raised-button color="primary" (click)="generateItems()" [disabled]="reading.isSaving || !hasSelectedRows">
                        {{ reading.isSaving ? 'Gerando...' : 'Gerar itens' }}
                    </button>
                    <button mat-button (click)="reading = null">Cancelar</button>
                </div>
            </ng-container>
        </section>

        <!-- Items -->
        <div class="header">
            <h4>Items</h4>
            <button mat-icon-button (click)="editItem()" title="Adicionar item">
                <mat-icon class="material-symbols-outlined">{{icons.add}}</mat-icon>
            </button>
        </div>

        <div *ngIf="isLoading">Carregando...</div>

        <div class="items">
            <div class="table-wrapper">
                <table mat-table [dataSource]="items">
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Date</th>
                        <td mat-cell *matCellDef="let i">{{ i.date }}</td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>Description</th>
                        <td mat-cell *matCellDef="let i">{{ i.description }}</td>
                    </ng-container>
                    <ng-container matColumnDef="category">
                        <th mat-header-cell *matHeaderCellDef>Category</th>
                        <td mat-cell *matCellDef="let i">{{ i.category }}</td>
                    </ng-container>
                    <ng-container matColumnDef="installment">
                        <th mat-header-cell *matHeaderCellDef>Installment</th>
                        <td mat-cell *matCellDef="let i">{{ i.installment ? i.installment + '/' + i.installments : '' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef class="value">Value</th>
                        <td mat-cell *matCellDef="let i" class="value">R$ {{ i.value | number:'1.2-2' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let i">
                            <button mat-icon-button (click)="editItem(i)"><mat-icon color="primary" class="material-symbols-outlined">{{icons.edit}}</mat-icon></button>
                            <button mat-icon-button (click)="deleteItem(i)"><mat-icon color="primary" class="material-symbols-outlined">{{icons.delete}}</mat-icon></button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columns"></tr>
                    <tr mat-row *matRowDef="let row; columns: columns;"></tr>
                </table>
                <p class="empty" *ngIf="!isLoading && !items.length">No items in this month.</p>
                <div class="total">Total: R$ {{ total | number:'1.2-2' }}</div>
            </div>

            <aside *ngIf="items.length" class="by-category">
                <h4>By category</h4>
                <div *ngFor="let c of byCategory" class="category-line">
                    <span class="swatch" [style.background]="c.color || 'transparent'" [class.none]="!c.color"></span>
                    <span class="name">{{ c.key }}</span>
                    <span class="amount">R$ {{ c.value | number:'1.2-2' }}</span>
                </div>
            </aside>
        </div>

        <!-- Same charts of the Overview, only for this card -->
        <div class="charts" *ngIf="categoryChart || descriptionChart">
            <section class="chart" *ngIf="categoryChart">
                <h4>By category</h4>
                <div class="canvas">
                    <canvas baseChart type="pie" [data]="categoryChart" [options]="pieOptions"></canvas>
                </div>
            </section>
            <section class="chart" *ngIf="descriptionChart">
                <h4>By description</h4>
                <div class="canvas">
                    <canvas baseChart type="bar" [data]="descriptionChart" [options]="barOptions"></canvas>
                </div>
            </section>
        </div>
    </ng-container>
</div>
